export const authTheme = {
  primary: '#6480f7',
  primaryRgb: '100, 128, 247',
  primaryGradient: 'linear-gradient(135deg, #6480f7 0%, #6d70f3 52%, #7967f4 100%)',
};
